import React from 'react';
import Div from '../Div';
import './nowShowingCard.scss';

export default function NowShowingCard({ poster, title, showTimes = [] }) {
  return (
    <Div className="cs-movie cs-style1">
      <Div className="cs-movie_thumb">
        <img src={poster} alt={title} />
        <Div className="cs-movie_overlay" />
      </Div>
      <Div className="cs-movie_info">
        <h2 className="cs-movie_title">{title}</h2>
        {showTimes.length > 0 && (
          <Div className="cs-movie_showtimes">{showTimes.join('  •  ')}</Div>
        )}
      </Div>
    </Div>
  );
}
